import { BeforeYouStartTemplate, ContentBody } from '@templates';
import { useNavigate } from 'react-router-dom';
import { CallToActionCardProps } from '@molecules/CallToActionCard/CallToActionCard';
import { RoutesList } from '../../../routes/Routes';
import {
  resetIssueDetails,
  resetUserDetails,
  useEVChargerStore,
} from '../../../../hooks/useEVChargerStore';
import { v4 as uuidv4 } from 'uuid';
import {
  FORM_LINK_TEXT,
  FORM_LINK_SUBTEXT,
  CHAT_LINK_TEXT,
  CHAT_LINK_SUBTEXT,
} from '@constants';

const ASSISTANT_URL = import.meta.env.VITE_ASSISTANT_URL;

export const BeforeYouStartPage = () => {
  const navigate = useNavigate();
  const { update } = useEVChargerStore();

  const contentTitle = 'Report an EV charging point issue';
  const sessionId = uuidv4();
  const initiateForm = () => {
    resetIssueDetails();
    resetUserDetails();
    update('wantConfirmationEmail', '');
    update('caseReferenceId', '');
    update('sessionId', sessionId);
    navigate(RoutesList.PROVIDER_SELECTION);
  };

  const reportItCTA: CallToActionCardProps = {
    linkText: FORM_LINK_TEXT,
    linkSubtext: FORM_LINK_SUBTEXT,
    onClick: initiateForm,
  };

  const reportItAssistantRoute = `${ASSISTANT_URL}?category=ev_charging`;
  const reportItAssistantCTA: CallToActionCardProps = {
    linkText: CHAT_LINK_TEXT,
    linkSubtext: CHAT_LINK_SUBTEXT,
    externalHref: reportItAssistantRoute,
  };

  const callToActionCards = [reportItAssistantCTA, reportItCTA];

  const detailsWeNeedContent = {
    sectionHeader:
      'You can use this form to report issues with EV charging services provided by ESB Energy, Shell Ubitricity, and Source London.',
    sectionTitle: `To help us resolve the issue, we need to know:`,
    itemList: [
      'the provider of the charging point',
      'details of the issue',
      'the location of the issue',
    ],
  };

  const usefulToIncludeContent = {
    sectionTitle: `It’s useful to provide:`,
    itemList: ['photos of the issue'],
  };

  const bodyContent = [detailsWeNeedContent, usefulToIncludeContent];

  const linkObjectArrays = [
    {
      level: 1,
      title: 'Home',
      href: 'https://www.westminster.gov.uk/',
    },
    {
      level: 2,
      title: 'Report it',
      href: 'https://www.westminster.gov.uk/report-it',
    },
    {
      level: 3,
      title: 'Report an EV charging point issue',
    },
  ];

  return (
    <BeforeYouStartTemplate
      contentTitle={contentTitle}
      contentSubtext={<ContentBody content={bodyContent} />}
      callToActionCards={callToActionCards}
      linkObjectArrays={linkObjectArrays}
    />
  );
};
